import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import Moment from 'moment';
import * as PathRouter from '../../../models/PathRoute'
import * as SubmissionStatus from '../../lms-shared/models/SubmissionStatus'
import mail from '../../../assests/learning-tracking/assessments/mail.png'
import attachmentsIcon from '../../../assests/learning-tracking/assessments/attachments.png'
import checked from '../../../assests/learning-tracking/assessments/checked.png'
import classes from './AssessmentEntry.module.css'
import { onKeyDown } from "../../../service";
import { submissionsApi } from "../../../utils";
import { throwApiError } from "../../lms-shared/store/error-handling-actions";

const AssessmentEntry = ({ row, title, index, currentTab, shortScoreCss, fromAdmin }) => {

    const { homeUrl } = useSelector(state => state.application);
    const texts = useSelector(state => state.translate.texts);

    const navigate = useNavigate();

    let { guid, id } = useParams();

    const dispatch = useDispatch();

    const EnterAssessment = (assessmentId) => {
        if (window.location.pathname.endsWith("assessments")) {
            if (fromAdmin)
                window.open(`./${PathRouter.ADMIN}/${PathRouter.SUBMISSION}/${assessmentId}`, '_blank');
            else
                navigate(`./${PathRouter.SUBMISSION}/${assessmentId}`)
        }
        else {
            if (fromAdmin)
                window.open(`../${PathRouter.ADMIN}/${PathRouter.SUBMISSION}/${assessmentId}`, '_blank');
            else
                navigate(`../${PathRouter.SUBMISSION}/${assessmentId}`)
        }
    }

    const GoToStudentTracking = (e) => {
        e.stopPropagation();
        // navigate(`../../${PathRouter.STUDENT_TRACKING}/${row.submittedByUserId}`)
        navigate(`${homeUrl}/${PathRouter.LEARNING_TRACKING}/${id}/${PathRouter.STUDENT_TRACKING}/${row.submittedByUserId}`)
    }

    const DownloadAssessment = (e) => {
        e.stopPropagation();
        const submissionsFilter = {
            submissionId: row.id,
            showPendingMsg: false,
        }
        submissionsApi.submissionsFilterPost({ submissionsFilter }, (error, resdata, response) => {
            if (error)
                dispatch(throwApiError({ userMessage: texts.submissionsFilterIdError, error: error, statusCode: response?.statusCode, message: "submissionsFilterIdPost " + error.message, level: 2, component: "AssessmentEntry", line: 70 }))
            else {
                let a = document.createElement('a');
                a.href = response.body.attachmentUrl;
                // For Firefox https://stackoverflow.com/a/32226068
                document.body.appendChild(a);
                a.click();
                a.remove();
            }
        })
    }

    const OpenSubmissionInNewTab = (e) => {
        e.stopPropagation();
        if (window.location.pathname.endsWith("assessments"))
            window.open(`./${PathRouter.SUBMISSION}/${row.id}`)
        else
            window.open(window.location.href.replace(`${PathRouter.ASSESSMENTS}`, `${PathRouter.SUBMISSION}`).replace(`${guid}`, `${row.id}`))
    }

    return (
        <div className={`${classes.AssessmentEntry} ${title ? classes.AssessmentEntryTitle : !(index % 2) ? classes.AssessmentEntryTransparent : ''}`} onClick={() => !title ? EnterAssessment(row.id) : null} tabIndex={!title ? "0" : null} role={!title ? "button" : null} onKeyDown={e => onKeyDown(e, () => !title ? EnterAssessment(row.id) : null)}>
            <div className={`${classes.AssessmentEntryText} ${fromAdmin ? classes.FromAdmin : ''}`}>
                {/* <div className={classes.CheckBox}>
                    {row.score ? <img src={checked} /> : ""}
                </div> */}
                <div className={classes.Number}>{!title ? index + 1 : ''}</div>

                {row.studyGroup && <div className={classes.StudyGroup}>{row.studyGroup}</div>}

                <div className={classes.Name}>{row.assessmentName}</div>

                <div className={classes.TeamContainer}>
                    <div className={`${classes.Team} ${row.submittedByUser?.isGroup ? classes.TeamName : ''}`}>{row.submittedByUser?.isGroup && row.submittedByUser?.name}</div>
                    {row.submittedByUser?.isGroup && <div className={`${row.submittedByUser?.name ? classes.TeamNameTooltip : ''}`}>{row.submittedByUser?.name}</div>}
                </div>

                {row.submittedByUser ?
                    <>
                        <div className={classes.NameWarrper}>
                            <div className={classes.Name2}>
                                {title ? '' :
                                    row.submittedByUser?.isGroup ?
                                        row.submittedByUser.users.map(u => u.firstName + ' ' + u.lastName).join(', ') :
                                        `${row.submittedByUser.firstName} ${row.submittedByUser.lastName}`
                                }
                                {row.submittedByUser?.isGroup && <div className={classes.Tooltip}>
                                    <span className={classes.tooltipText}>{row.submittedByUser.users.map(u => u.firstName + ' ' + u.lastName).join(', ')}</span>
                                </div>}
                            </div>
                        </div>
                    </>
                    : ''

                }

                <div className={`${classes.Date} ${currentTab == 2 && classes.SubmittedDate}`}>
                    {row.submittedDate && <div style={row.assessmentDueDate && row.submittedDate > row.assessmentDueDate ? { color: "red" } : {}}> {title ? row.submittedDate : Moment(row.submittedDate).format('DD/MM/YY')}</div>}
                </div>

                {currentTab == 2 && <div className={classes.Date}>
                    {row.statusChangedDate &&
                        <div> {row.statusChangedDate instanceof Date ? Moment(row.statusChangedDate).format('DD/MM/YY') : row.statusChangedDate}</div>
                    }
                </div>}

                {title ? <div className={classes.ScoreTitle}>{row.score}</div>
                    : <div className={`${classes.ScoreWrapper} ${shortScoreCss ? classes.shortScoreWrapper : ''}`}>
                        {row.submissionStatusId === SubmissionStatus.rejected ?
                            <div className={classes.NeedToFix}>{texts.fix}</div> :
                            <div className={classes.ScoreWrap}>
                                {row.score && <>
                                    {(() => {
                                        let scoreAdditionalData = JSON.parse(row.scoreAdditionalData);
                                        return (scoreAdditionalData && <>
                                            {!scoreAdditionalData.verbalFeedbackText && <div className={classes.ScoreDescription}>{Math.round(scoreAdditionalData.weightedScore)}</div>}
                                            {scoreAdditionalData.verbalFeedbackText && <div className={classes.Score}>{scoreAdditionalData.verbalFeedbackText}</div>}
                                        </>)
                                    })()}

                                </>}
                            </div>
                        }
                    </div >}

            </div>
            {!title && !fromAdmin && <div className={classes.AllIcons}>
                {/* hide stats and download options */}
                <div className={`${classes.Icon} ${classes.ShowStudent}`} onClick={(e) => GoToStudentTracking(e)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => GoToStudentTracking(e))} title={texts.viewStudents}></div>
                <div className={`${classes.Icon} ${classes.DownloadAssessment}`} onClick={(e) => DownloadAssessment(e)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => DownloadAssessment(e))} title={texts.download}></div>
                {/* TODO where to take mail from?*/}
                <div>
                    {row.pendingMessagesCount > 0 ? <div className={classes.MailIcon}>
                        <img className={classes.MailImg} src={mail} alt="mail" />
                        <div className={classes.UnReadMsg}>{row.pendingMessagesCount}</div>
                    </div> : ""}
                </div>
                <div className={classes.Attachments}>{row.contentData && JSON.parse(row.contentData)?.Attachments?.length > 0 && <img src={attachmentsIcon} alt="attachments" />}</div>
                <div className={`${classes.Icon} ${classes.OpenInNewTab}`} onClick={(e) => OpenSubmissionInNewTab(e)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => OpenSubmissionInNewTab(e))}></div>
            </div >}
        </div>

    )
}

export default AssessmentEntry;

